<app-spinner *ngIf="viewSpinner"></app-spinner>
<app-header [nomModule]="nomModule"></app-header>
<mat-card-content>
    <p>Data</p>
</mat-card-content>